<template lang="pug">
v-form
  v-row
    v-col(cols="12")
      TitleTextField(:panel-identifier="panelIdentifier")
  DateAndTimeFields(:panel-identifier="panelIdentifier")
  DescriptionFields(:panel-identifier="panelIdentifier")
</template>

<script lang="ts">
import Subtitle from "../../../../components/UI/Subtitle.vue"
import { defineComponent } from "vue"
import { PanelDefinition } from "features/events/form/FormExpansionPanel.vue"
import { PanelIdentifier } from "features/events/form/event-form.types"
import OrganizerFields from "components/EventForm/OrganizerFields.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import TitleTextField from "features/events/form/general-fields/TitleTextField.vue"
import OnlineConferenceField from "features/events/form/general-fields/OnlineConferenceField.vue"
import DateAndTimeFields from "features/events/form/general-fields/DateAndTimeFields.vue"
import ParticipationCircleFields from "features/events/form/general-fields/ParticipationCircleFields.vue"
import DescriptionFields from "features/events/form/general-fields/DescriptionFields.vue"

const GeneralFields = defineComponent({
  name: "GeneralFields",
  components: {
    DescriptionFields,
    ParticipationCircleFields,
    DateAndTimeFields,
    OnlineConferenceField,
    TitleTextField,
    OrganizerFields,
    Subtitle,
  },
  computed: {
    panelIdentifier(): PanelIdentifier {
      return PanelIdentifier.GENERAL
    },
  },
  setup() {
    const { t$ } = useTranslate("components.event_form")

    return {
      t$,
    }
  },
})
export default GeneralFields

export const GeneralFieldsDefinition: PanelDefinition = {
  key: "general",
  component: GeneralFields,
  id: PanelIdentifier.GENERAL,
}
</script>
